/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race-by-race F1 Fantasy points for every driver and constructor — broken down by qualifying, sprint, and race sessions. See exactly why a pick scored high or underperformed each weekend.`)
};

const es_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntos de F1 Fantasy carrera por carrera para cada piloto y constructor — desglosados por sesiones de clasificación, sprint y carrera. Observa exactamente por qué un pick puntuó alto o bajo cada fin de semana.`)
};

const de_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rennen-für-Rennen F1-Fantasy-Punkte für jeden Fahrer und Konstrukteur — aufgeschlüsselt nach Qualifying-, Sprint- und Renn-Sessions. Sieh genau, warum ein Pick an jedem Wochenende gut oder schlecht abgeschnitten hat.`)
};

const nl_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race-voor-race F1 Fantasy-punten voor elke coureur en constructeur — uitgesplitst per kwalificatie-, sprint- en racesessie. Bekijk precies waarom een pick elk weekend hoog of laag scoorde.`)
};

const fr_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points F1 Fantasy course par course pour chaque pilote et constructeur — détaillés par sessions de qualification, sprint et course. Voyez exactement pourquoi un pick a bien ou mal performé chaque week-end.`)
};

const it_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti F1 Fantasy gara per gara per ogni pilota e costruttore — suddivisi per sessioni di qualifica, sprint e gara. Scopri esattamente perché una scelta ha reso bene o male ogni weekend.`)
};

const pt_br2_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos de F1 Fantasy corrida por corrida para cada piloto e construtor — detalhados por sessões de classificação, sprint e corrida. Veja exatamente por que uma escolha pontuou alto ou baixo em cada fim de semana.`)
};

const pt_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontos de F1 Fantasy corrida a corrida para cada piloto e construtor — detalhados por sessões de qualificação, sprint e corrida. Veja exatamente porque é que uma escolha pontuou alto ou baixo em cada fim de semana.`)
};

const ja_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全ドライバーとコンストラクターのレースごとのF1ファンタジーポイント — 予選、スプリント、レースセッション別に分類。毎週末、なぜそのピックが高得点または低得点だったかを正確に確認できます。`)
};

const zh_f1_points_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每位车手和车队的逐场F1梦幻积分 — 按排位赛、冲刺赛和正赛分类。精确了解每个周末为什么某个选择得分高或表现不佳。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_intro", locale)
	if (locale === "en") return en_f1_points_intro(inputs)
	if (locale === "es") return es_f1_points_intro(inputs)
	if (locale === "de") return de_f1_points_intro(inputs)
	if (locale === "nl") return nl_f1_points_intro(inputs)
	if (locale === "fr") return fr_f1_points_intro(inputs)
	if (locale === "it") return it_f1_points_intro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_intro(inputs)
	if (locale === "pt") return pt_f1_points_intro(inputs)
	if (locale === "ja") return ja_f1_points_intro(inputs)
	return zh_f1_points_intro(inputs)
};